import { createSlice } from "@reduxjs/toolkit";

const initialModule = {
  parentId: 0,
  name: "",
  key: "",
  icon: "",
  link: "",
  order: 0,
  isInLeftMenu: true,
  authorityIds: []
};
  
const initialModulesState = {
  listLoading: false,
  actionsLoading: false,
  asideMenuList: [],
  entities: [],
  module: initialModule
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const moduleSlice = createSlice({
  name: "modules",
  initialState: initialModulesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getAsideMenuList
    asideMenuFetched: (state, action) => {
      state.asideMenuList = action.payload;
    },
    // getModules
    modulesFetched: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.entities = action.payload.entities;
    },
    // getModule
    moduleFetched: (state, action) => {
      state.actionsLoading = false;
      state.module = action.payload || initialModule;
    },
    // saveModule
    moduleSaved: (state) => {
      state.actionsLoading = false;
    },
    // cleanAsideMenuListState
    asideMenuListCleaned: (state, action) => {
      state.asideMenuList = [];
    },
    // cleanModulesState
    modulesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = [];
      state.module = initialModule;
    }
  }
});